
import { Component, Vue, Prop } from 'vue-property-decorator';
import OrderReferenceField from '@/components/orders/new-order/OrderReferenceField.vue';
import ShipToField from '@/components/orders/new-order/ShipToField.vue';
import DeliveryDateField from '@/components/orders/new-order/DeliveryDateField.vue';
import NewOrderFooter from '@/components/orders/new-order/NewOrderFooter.vue';

@Component({
  components: {
    DeliveryDateField,
    OrderReferenceField,
    ShipToField,
    NewOrderFooter,
  },
})
export default class OrderReferenceAndShipping extends Vue {
  @Prop(Boolean)
  isInvalid!: boolean;
}
